<template>
  <header :class="$style.root">
    <div :class="$style.content">
      <h1 :class="$style.title">{{ page?.title }}</h1>
      <div :class="$style.stroke" />
      <div :class="$style.information">
        <div
          v-if="tags || page?.highlighted"
          :class="$style.tags"
        >
          <template v-for="(tag, index) in tags" :key="index"><span :class="$style.tag">{{ tag?.trim() }}</span>&nbsp;</template>

          <span
            v-if="page?.highlighted"
            :class="$style.tag"
          >
            {{ $t('shared.highlight') }}
          </span>
        </div>
        <div v-if="page?.datePosted">
          {{ $t('shared.datePosted') }}:
          <CoreDateTimeRangeComponent
            :dateStart="page?.datePosted"
            format="D MMMM YYYY"
          />
        </div>
      </div>
    </div>
  </header>
</template>

<script lang="ts" setup>
const props = defineProps<{
  page: object
}>()

const route = useRoute()
const query = computed(() => route?.query)

const tags = props?.page?.journalTags?.data?.map(i => i?.attributes?.label)?.filter(Boolean)
</script>

<style module>
.root {
  composes: container from global;

  margin-bottom: calc(var(--unit--vertical) * 2);
}

.content {
  /* NOTE to compensate for the container--100vw--background stroke */
  margin-left: calc(var(--stroke--medium) / 2);
  margin-right: calc(var(--stroke--medium) / 2);

  margin-bottom: calc(var(--unit--vertical) * 2);
}

.title {
  composes: reset-heading from global;
  composes: font-size-x-large from global;
}

.stroke {
  margin-left: calc((var(--unit--default) / 2) * -1);
  margin-right: calc((var(--unit--default) / 2) * -1);

  /* NOTE UNIFY */
  border-bottom: var(--stroke--medium) solid;
  padding-bottom: calc(var(--stroke--medium) * 2);

  grid-column: 1 / -1;
}

.information {
  composes: font-size-small font-helvetica from global;
  margin-top: var(--lh);
}

.tags {
}

.tag {
  composes: font-size-small font-helvetica label-inverted from global;
}
</style>
